import React, { useState } from 'react'
import {
  PlayButton,
  VideoImageContainer,
  VideoImage,
  VideoOverlay,
} from './styles'

import Backdrop from '@material-ui/core/Backdrop'
import ImgUtil from '../../../utils/img.utils'
import DottedModal from '../dottedModal'
import WrapperImage from '../wrapperImage'

/// video player code thats pretty solid - sukhi
/// only needs the video ID

type VideoPlayerProps = {
  videoId: string
  width: string
  height: string
  img: string
  type?: string
  start?: string
  backgroundAltText?: string
  backgroundImgParams?: string
  outerPage?: string
  animationFileUrl?: string
}

const VideoPlayer = ({
  videoId,
  width,
  height,
  img,
  type = 'youtube',
  start,
  backgroundAltText = '',
  backgroundImgParams = '',
  outerPage = '',
  animationFileUrl,
}: VideoPlayerProps) => {
  const vidWidth = width === '100%' ? '100%' : `${width}px`

  const [open, setOpen] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const url: { [key: string]: string } = {
    youtube: 'https://www.youtube.com/embed',
    vimeo: 'https://player.vimeo.com/video',
  }

  let src = ''

  if (videoId) {
    src = `${url[type]}/${videoId}`

    // videoId can contain query string (vimeo)
    // video will not have autoplay/start if not valid url
    try {
      let videoEmbedUrl = new URL(src)
      if (videoEmbedUrl.search) {
        src += '&autoplay=1'
      } else {
        src += '?autoplay=1'
      }
      src += start ? `&start=${start}` : ''
    } catch (err) {
      console.log(err)
    }
  } else if (animationFileUrl) {
    src = animationFileUrl
  }

  return (
    <React.Fragment>
      <DottedModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        handleClose={handleClose}
        closeAfterTransition
        type="video"
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <iframe
          width="100%"
          height={height || '475'}
          src={src}
          frameBorder="0"
          allowFullScreen
          data-cy={`VideoPlayer-Modal--${type}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </DottedModal>
      <VideoImageContainer $outerPage={outerPage}>
        <VideoImage
          onClick={handleOpen}
          data-cy="VideoPlayer-Image"
          $outerPage={outerPage}
        >
          <WrapperImage
            src={ImgUtil.getResizedImageUrl(img, backgroundImgParams)}
            alt={backgroundAltText}
            className="VideoPlayer__Image-File"
            height={479}
            width={792}
            threshold={650}
          />
          <PlayButton />
          <VideoOverlay />
        </VideoImage>
      </VideoImageContainer>
    </React.Fragment>
  )
}
export default VideoPlayer
